// ink-component
import React from 'react';
import { formatPercent } from '@carta/pen';

import getGlobalProps from '../../helpers/constants/global-props';

import getNumberValue from '../_common/helpers/getNumberValue';

export interface FormattedPercentageProps {
  /** Original value to be formatted */
  value?: number | string;
  /** Number of decimal places */
  precision?: number;
  /** Defines if the percentage is calculated in absolute terms */
  absolute?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** @deprecated:none Zeros are now always shown by default */
  allowZero?: boolean;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Formats percentage values
 * @group Formatted
 * @categories formatter
 */
function FormattedPercentage(props: FormattedPercentageProps) {
  const { precision, value, absolute } = props;
  const adjustedValue = getNumberValue(value);

  if (adjustedValue === undefined) {
    return null;
  }

  const configuredPercent = (value: number) => formatPercent(value, { alwaysShow: true, precision });

  return (
    <span {...globalProps} data-testid={props['data-testid']}>
      {absolute ? configuredPercent(Math.abs(adjustedValue)) : configuredPercent(adjustedValue)}
    </span>
  );
}

FormattedPercentage.defaultProps = {
  value: null,
  precision: 2,
  absolute: false,
  'data-testid': undefined,
};

FormattedPercentage.displayName = 'FormattedPercentage';

export default FormattedPercentage;
